// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__wrapper-xUuLaG","tooltip":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__tooltip-UVQwyu","hovered":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__hovered-g7WvzJ","content":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__content-qh3ahv","kbdWrapper":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__kbdWrapper-C1UemM","kbd":"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__kbd-GQWAVu"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__wrapper-xUuLaG\",\"tooltip\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__tooltip-UVQwyu\",\"hovered\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__hovered-g7WvzJ\",\"content\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__content-qh3ahv\",\"kbdWrapper\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__kbdWrapper-C1UemM\",\"kbd\":\"src-shared-components-HotkeyTooltip-HotkeyTooltip-module__kbd-GQWAVu\"}";
        // 1793875575788
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  